import cx from 'classnames';
import * as React from 'react';
import { useLocalize } from './localize-context';

type PriceDisplayProps = {
  type: 'adult' | 'kid' | 'both';
  price: number | null;
  className?: string;
};

export const PriceDisplay = (props: PriceDisplayProps) => {
  const localize = useLocalize();

  if (props.price === null) {
    return null;
  }
  return (
    <div className={cx('inline-flex items-end', props.className)}>
      <div className="text-right mr-1">
        <div className="text-lg lg:text-xl text-gray-700">
          {localize(label[props.type])}
        </div>
        <div className="text-sm lg:text-lg">{localize('RM')}</div>
      </div>
      <div
        className={cx(
          'leading-none',
          props.type === 'kid' ? 'text-4xl lg:text-5xl' : 'text-5xl lg:text-6xl'
        )}
      >
        {props.price}
      </div>
    </div>
  );
};

const label = {
  adult: 'Adult',
  kid: 'Kid',
  both: 'AdultOrKid',
} as const;
